import React from "react";
import { createRoot } from "react-dom/client";
import moment from "moment";
import * as Sentry from "@sentry/react";
import { Provider } from "react-redux";
// @ts-expect-error translations is a generated module (see config/rsbuild/pluginRailsTranslations.mjs)
import translations from "translations";
// Moment only ships "en" preloaded and its runtime locale require is invisible
// to the bundler, so every non-English locale has to be imported explicitly -
// otherwise .locale("cs") silently falls back to English.
import "moment/locale/cs";
import "../stylesheets/base.css";
import "../stylesheets/tailwind.css";
import App from "./App";
import { store } from "./shared/redux/configureStore";
import { resolveLocale } from "./utils/locale";
import LocaleProvider from "./shared/providers/I18nProvider";

// Importing a locale also makes it moment's global default (defineLocale ends
// in getSetGlobalLocale), so pin the global explicitly instead of letting it
// fall out of import order. Call sites still pass .locale(locale) themselves
// because the user can switch locale at runtime.
const initialLocale = resolveLocale();
moment.locale(initialLocale);

Sentry.init({
    dsn: process.env.SENTRY_CLIENT_DSN,
    release: process.env.SENTRY_RELEASE,
    environment: process.env.RAILS_ENV,
    autoSessionTracking: true,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 0.5,
});

document.addEventListener("DOMContentLoaded", () => {
    const root = createRoot(document.getElementById("root")!);
    root.render(
        <Provider store={store}>
            <LocaleProvider defaultLocale={initialLocale} messages={translations}>
                <React.StrictMode>
                    <App />
                </React.StrictMode>
            </LocaleProvider>
        </Provider>,
    );
});
